let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("14Shs")).then(() => parcelRequire('az1yO'));